import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import { axiosInstance } from "@helpers/axios-instance";
import { FilterDescriptor } from "devextreme/data";
import { HOUSEHOLD_GRID_NO_DATA_MSG } from "@/types/enums";
import { HOUSEHOLD_GRID_MIN_SEARCH_LENGTH } from "@/constants/constants";
import { DataAwareResponse, Household } from "@/types/types";
import { LoadResultObject } from "devextreme/common/data/custom-store";

const isFilterValueLongerThanMin = (loadOptions: FilterDescriptor) => {
  if (!loadOptions?.filter) return false;

  return loadOptions.filter.some((filter: FilterDescriptor) => {
    if (Array.isArray(filter)) {
      const filterValue = (filter as FilterDescriptor)?.filterValue as string;
      return filterValue?.length > HOUSEHOLD_GRID_MIN_SEARCH_LENGTH;
    }
    return false;
  });
};

type Props = {
  setErrorMsg: React.Dispatch<
    React.SetStateAction<HOUSEHOLD_GRID_NO_DATA_MSG | undefined | string | string[]>
  >;
};

export function HouseholdSFDS({ setErrorMsg }: Props) {
  return new DataSource({
    store: new CustomStore({
      key: "externalCode",
      load: async (loadOptions) => {
        const isValid = isFilterValueLongerThanMin(loadOptions);

        if (!isValid) {
          setErrorMsg(HOUSEHOLD_GRID_NO_DATA_MSG.QueryTooShort);
          return { data: [], totalCount: 0 };
        }

        try {
          const response = await axiosInstance<DataAwareResponse<LoadResultObject<Household>>>({
            method: "POST",
            url: `Household/GridSF`,
            data: loadOptions,
          });

          const data = response.data?.data;

          if (response.data.validation.items.length > 0) {
            const msgs = response.data.validation.items.map((item) => item.message);
            setErrorMsg(msgs);
            return { data: [], totalCount: 0 };
          }

          if (data.totalCount === 0) {
            setErrorMsg(HOUSEHOLD_GRID_NO_DATA_MSG.NoData);
            return { data: [], totalCount: 0 };
          }

          return data;
        } catch (err) {
          setErrorMsg(HOUSEHOLD_GRID_NO_DATA_MSG.ErrorLoadingData);
          return { data: [], totalCount: 0 };
        }
      },
      byKey: async (key) => {
        return axiosInstance({
          method: "GET",
          url: `Household/Get/${key}`,
        })
          .then((response) => {
            return response.data.data;
          })
          .catch((err) => {
            console.error(err);
          });
      },
    }),
  });
}
